module.exports = __webpack_public_path__ + "bh.no1.82206ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bh.no1.jpg
// module id = l3+x
// module chunks = 0